"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseUtils = void 0;
;
var PromiseUtils = /** @class */ (function () {
    function PromiseUtils() {
    }
    // inspired by: http://bluebirdjs.com/docs/api/promise.props.html
    // taken from: https://stackoverflow.com/questions/44600771/equivalent-of-bluebird-promise-props-for-es6-promises
    PromiseUtils.props = function (obj) {
        // keys and values will be in the same order
        var keys = Object.keys(obj);
        var values = Object.values(obj);
        return Promise.all(values)
            .then(function (resolvedValues) {
            var result = {};
            for (var idx = 0; idx < keys.length; ++idx) {
                result[keys[idx]] = resolvedValues[idx];
            }
            return result;
        });
    };
    return PromiseUtils;
}());
exports.PromiseUtils = PromiseUtils;
//# sourceMappingURL=PromiseUtils.js.map